import CalendarPendingSVG from "@design-system/ui-icons/vanilla/CalendarPending"
import { createIcon } from "../createIcon"

export const CalendarPendingIcon = createIcon(CalendarPendingSVG)
